import { isBefore } from "date-fns";

import { DatasetPurpose } from "src/api/types";

export const TEST_DATASET_START_DATE = new Date("2023-04-01");

export type DateRangeMode = "time_window" | "traffic_policy";

export const isStartDateBeforeAvailableData = (
  timeWindowStart: string,
  purpose: DatasetPurpose | undefined,
  dhv2MinDate: Date | undefined,
): boolean => {
  if (purpose !== "simulation") {
    return isBefore(new Date(timeWindowStart), TEST_DATASET_START_DATE);
  }
  if (!dhv2MinDate) return false;
  return isBefore(new Date(timeWindowStart), dhv2MinDate);
};

export const isSimulationDateBeforeAvailableData = (
  purpose: DatasetPurpose | undefined,
  dateRangeMode: DateRangeMode,
  startDateBefore: boolean,
  trafficPolicyBefore: boolean,
): boolean => {
  return (
    purpose === "simulation" &&
    (dateRangeMode === "traffic_policy" ? trafficPolicyBefore : startDateBefore)
  );
};
